import { graphql } from 'react-relay';

export const cutOffTableHeaderFragment = graphql`
    fragment CutOffTableHeader_header on CutOffTable {
        tableHeader {
            col
            label
        }
    }
`;
